/* global ImagesURL */

import React from 'react';
import {useQuery} from 'react-query';
import {connect} from 'react-redux';

import RegionProvider from './RegionProvider';
import WeatherImageSelector from './WeatherImageSelector';

const WeatherImageDataQuery = ({product, offset, index, zIndex}) => {
    const params = {product, offset, index};
    const queryKey = [ImagesURL, params];
    const {data: images} = useQuery(queryKey, {
        keepPreviousData: true,
        select({data}) {
            return data;
        },
    });

    if (!images) return null;

    return (
        <RegionProvider images={images}>
            <WeatherImageSelector zIndex={zIndex} />
        </RegionProvider>
    );
};

const mapStateToProps = ({productID, offset, index}) => ({
    product: productID,
    offset,
    index,
});

export default connect(mapStateToProps)(WeatherImageDataQuery);
